import { matchingModelSelector } from "app/datamodel/Features/selectors";

export const isPremiumEnabledSelector = matchingModelSelector;
